<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.listenTable.contentArea.title') }}</h2>
        </div>
        <div class="card-body d-flex flex-column p-9">
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listenTable.contentArea.cols.content') }}</label>
                <el-form-item prop="data.data.content" :rules="$validation.getMessage(['required'])">
                    <CustomCkeditor :model="data.content" @updateModel="data.content = $event"></CustomCkeditor>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listenTable.contentArea.cols.dragArea') }}</label>
                <el-form-item prop="track_id">
                    <el-upload :file-list="track.fileList" :accept="$root.acceptFileSupported('sound', '.')" class="upload-file" :on-change="handleChangeTrack" :on-remove="handleChangeTrack" :auto-upload="false" drag :multiple="false" :limit="1">
                        <el-icon class="el-icon--upload">
                             <span class="svg-icon">
                                 <inline-svg src="/media/icons/duotune/files/fil022.svg"/>
                             </span>
                        </el-icon>
                        <div class="el-upload__text">{{ $t('pages.module.eTep.question.save.questionType.listenTable.contentArea.cols.dragAreaContent') }}</div>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listenTable.contentArea.cols.image') }}</label>
                <el-form-item prop="upload_id">
                    <el-upload :file-list="image.fileList" :accept="$root.acceptFileSupported('image', 'image/')" class="upload-file" :on-change="handleChangeImage" :on-remove="handleChangeImage" :auto-upload="false" drag :multiple="false" :limit="1">
                        <el-icon class="el-icon--upload">
                             <span class="svg-icon">
                                 <inline-svg src="/media/icons/duotune/files/fil022.svg"/>
                             </span>
                        </el-icon>
                        <div class="el-upload__text">{{ $t('pages.module.eTep.question.save.questionType.listenTable.contentArea.cols.dragAreaImageContent') }}</div>
                    </el-upload>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.listenTable.contentArea.cols.beforePlayWaitingSecond') }}</label>
                <el-form-item :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.before_play_waiting_second" :min="1" :max="120"/>
                </el-form-item>
            </div>
        </div>
    </div>
    <div class="card mt-7">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.listenTable.table.title') }}</h2>
            <div class="card-toolbar">
                <div class="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
                    <button class="btn btn-flex btn-primary" v-on:click="addRow" type="button">
                        <span class="svg-icon svg-icon-2">
                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                        </span>
                        {{ $t('pages.module.eTep.question.save.questionType.listenTable.table.addRow') }}
                    </button>
                    <button class="btn btn-flex btn-primary" v-on:click="addColumn" type="button">
                        <span class="svg-icon svg-icon-2">
                            <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                        </span>
                        {{ $t('pages.module.eTep.question.save.questionType.listenTable.table.addColumn') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="card-body d-flex flex-column p-9">
            <div class="fv-row mb-7">
                <div class="table-responsive">
                    <table class="table-auto w-full border border-gray-300">
                        <thead>
                        <tr class="bg-gray-100">
                            <th class="border px-4 py-2"></th>
                            <th v-for="(col, colIndex) in data.table.column" :key="colIndex" class="border px-4 py-2">
                                <div class="d-flex align-items-center justify-content-between gap-5 width-max-content my-5" style="min-width: max-content">
                                    <el-form-item :prop="'data.data.table.column[' + colIndex + '].title'" :rules="$validation.getMessage(['required'])" class="m-0">
                                        <el-input v-model="col.title" :placeholder="$t('pages.module.eTep.question.save.questionType.listenTable.table.cols.colPlaceholder')"/>
                                    </el-form-item>
                                    <button @click="removeColumn(colIndex)" class="btn btn-danger btn-sm" type="button"><i class="fa fa-trash-alt"></i></button>
                                </div>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, rowIndex) in data.table.row" :key="rowIndex">
                            <th class="border px-4 py-2">
                                <div class="d-flex align-items-center justify-content-between gap-5 width-max-content my-5" style="min-width: max-content">
                                    <el-form-item :prop="'data.data.table.row[' + rowIndex + '].title'" :rules="$validation.getMessage(['required'])" class="m-0">
                                        <el-input v-model="row.title" :placeholder="$t('pages.module.eTep.question.save.questionType.listenTable.table.cols.rowPlaceholder')"/>
                                    </el-form-item>
                                    <button @click="removeRow(rowIndex)" class="btn btn-danger btn-sm" type="button"><i class="fa fa-trash-alt"></i></button>
                                </div>
                                <div class="d-flex align-items-center justify-content-between gap-5 width-max-content">

                                </div>
                            </th>
                            <td
                                v-for="(col, colIndex) in data.table.column"
                                :key="colIndex"
                                class="border px-4 py-2 text-center"
                            >
                                <label class="custom-radio-wrapper">
                                    <input
                                        type="radio"
                                        :name="'row-' + rowIndex"
                                        :value="col.hash"
                                        v-model="correctAnswer[row.hash]"
                                        class="custom-radio-input"
                                    />
                                    <span class="custom-radio-mark"></span>
                                </label>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomCkeditor from "@/components/custom-ckeditor/index.vue";
import md5 from 'md5'

export default {
    name: "Paragraph",
    props: {
        data: Object,
        updateStatus: Boolean,
        image: Object,
        track: Object,
        correctAnswer: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            paragraphPreview: true,
            newColumn: '',
        }
    },
    components: {
        CustomCkeditor
    },
    methods: {
        addColumn() {
            this.data.table.column.push({
                "hash": this.generateHash(),
                "title": '',
            })
        },
        removeColumn(index) {
            this.data.table.column.splice(index, 1)
        },
        addRow() {
            const hash = this.generateHash();
            this.data.table.row.push({
                "hash": hash,
                "title": '',
            })
            this.correctAnswer[hash] = '';
        },
        removeRow(index) {
            this.data.table.row.splice(index, 1)
        },
        generateHash() {
            const timestamp = Date.now().toString()
            const random = Math.random().toString(36).substring(2, 10)
            const input = `${timestamp}-${random}`
            this.paragraphPreview = true
            return md5(input);
        },
        handlePictureCardPreview(file) {
            this.image.dialogImageUrl = file.url
            this.image.dialogVisible = true
        },
        handleChangeImage(file, fileList) {
            this.image.fileList = fileList;
            this.image.uploadList = fileList;
        },
        handleChangeTrack(file, fileList) {
            this.track.fileList = fileList;
            this.track.uploadList = fileList;
        }
    }
};
</script>

<style>
.width-max-content {
    min-width: max-content;
}

.custom-radio-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    width: 24px;
    height: 24px;
}

.custom-radio-input {
    opacity: 0;
    position: absolute;
    width: 0;
    height: 0;
}

.custom-radio-mark {
    width: 18px;
    height: 18px;
    border: 2px solid #e2e2e2;
    border-radius: 50%;
    background-color: #fff;
    transition: all 0.2s ease;
    box-shadow: 0 0 0 2px transparent;
}

.custom-radio-wrapper:hover .custom-radio-mark {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
}

.custom-radio-input:checked + .custom-radio-mark {
    border-color: #409EFF;
    background-color: #409EFF;
    box-shadow: inset 0 0 0 4px #fff;
}

</style>
